"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _CoordinatorList = _interopRequireDefault(require("@/components/CoordinatorList.vue"));
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    CoordinatorList: _CoordinatorList.default
  },
  data: function data() {
    return {
      actNum: 0,
      navList: [{
        name: "思政课程"
      }, {
        name: "课程思政"
      }, {
        name: "专题活动"
      }, {
        name: "班主任辅导工作"
      }],
      kcszList: [],
      page: {
        pageNumber: 1,
        pageSize: 20
      },
      reNewsInfo: [{
        newsTitle: "中国特色社会主义",
        num: 1
      }, {
        newsTitle: "心理健康教育与职业生涯",
        num: 2
      }, {
        newsTitle: "哲学与人生",
        num: 3
      }, {
        newsTitle: "职业道德与法治",
        num: 4
      }],
      reNewsInfo1: [{
        newsTitle: "毛泽东思想和中国特色社会主义理论体系概论",
        num: 5
      }, {
        newsTitle: "思想道德与法治",
        num: 6
      }],
      total: 0,
      loading: false
    };
  },
  created: function created() {
    this.getCourseList2();
  },
  methods: {
    tabChange: function tabChange(index) {
      this.actNum = index;
      if (index === 1) {
        this.getCourseList2();
      }
    },
    handleSizeChange: function handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNumber = 1;
      this.getCourseList2();
    },
    handleCurrentChange: function handleCurrentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getCourseList2();
    },
    lookDetail: function lookDetail(url) {
      window.open(url);
    },
    goCharacteristics: function goCharacteristics(item) {
      this.$router.push({
        path: "/characteristics",
        query: {
          num: item.num,
          courseName: item.newsTitle
        }
      });
    },
    getCourseList2: function getCourseList2() {
      var _this = this;
      this.kcszList = [];
      this.loading = true;
      this.total = 0;
      (0, _index.getReceptionList)({
        courseName: "",
        courseSource: "",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        projectLevel: "",
        provinceId: this.$store.getters.provinceId,
        courseType: "2",
        schoolId: "",
        majorName: "",
        isSpecial: true,
        showStatus: 1
      }).then(function (res) {
        _this.kcszList = res.rows || [];
        _this.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};